import { READING_DARK_MODE_COOKIE, READING_DARK_MODE_COOKIE_BASE_OPTIONS, READING_HAS_LICENSE_COOKIE } from '#shared/cookies'

// SSR only. Client-side navigations are handled at page-swap time by useReadingModeSync
export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.client) {
    return
  }

  const colorMode = useColorMode()
  const hasLicense = useHasLicense()
  const readingDarkMode = useCookie(READING_DARK_MODE_COOKIE, READING_DARK_MODE_COOKIE_OPTIONS)

  const preference = resolveReadingPreference(to.path, to.hash, hasLicense.value && readingDarkMode.value)
  if (colorMode.preference !== preference) {
    colorMode.preference = preference
  }

  if (isReadingRoute(to.path, to.hash)) {
    const hasLicenseCookie = useCookie(READING_HAS_LICENSE_COOKIE, READING_DARK_MODE_COOKIE_BASE_OPTIONS)
    hasLicenseCookie.value = hasLicense.value ? 'true' : 'false'
  }
})
